import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UrlConstants } from "../models/urlConstants";

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  private configUrl = "assets/identity/config.json";

  feedUrl: string;
  backofficeUrl: string;
  egxUrl: string;
  newSignalR: string;
  globalDataApi: string;
  appKey: string;
  idleTime: number;
  isEGID: boolean;
  enableIPO:boolean;
  enableMutualFund:boolean;
  reportsUrl: string; 
  constructor(private http: HttpClient) {
    this.getConfigServers().subscribe((res) => {
      this.feedUrl = res["feedUrl"];
      this.backofficeUrl = res["backofficeUrl"];
      this.newSignalR = res["newSignalR"];
      this.egxUrl = res["egxUrl"];
      this.reportsUrl = res["reportsUrl"];
      this.globalDataApi = res["globalDataApi"];
      this.appKey = res["appKey"];
      this.idleTime = res["idleTime"];
      this.isEGID = res['isEGID'];
      this.enableIPO = res['enableIPO'];
      this.enableMutualFund = res['enableMutualFund'];
    });
  }

  Init() {
    return new Promise<void>((resolve, reject) => {
      this.getConfigServers().subscribe((data) => {
        UrlConstants.backofficeUrl = data["backofficeUrl"];
        UrlConstants.feedUrl = data["feedUrl"];
        UrlConstants.egxUrl = data["egxUrl"];
        UrlConstants.newSignalR = data["newSignalR"];
        UrlConstants.globalDataApi = data["globalDataApi"];
        UrlConstants.appKey = data["appKey"];
        UrlConstants.reportsUrl = data["reportsUrl"];
        UrlConstants.idleTime = data["idleTime"];
        UrlConstants.supportNumber = data["supportNumber"];
        UrlConstants.navButtonColor = data["navButtonColor"];
        UrlConstants.companyName = data["companyName"];
        UrlConstants.hasTechnicalAnalysis = data["hasTechnicalAnalysis"];
        UrlConstants.hasFundmentalAnalysis = data["hasFundmentalAnalysis"];
        UrlConstants.isEGID = data["isEGID"];
        UrlConstants.logoLink = data["logoLink"];
        UrlConstants.enableIPO = data["enableIPO"];
        UrlConstants.enableMutualFund = data["enableMutualFund"];
        resolve();
      });
    });
  }

  public getConfigServers() {
    return this.http.get(this.configUrl);
  }

  fetchServers() {
    this.getConfigServers().subscribe((res) => {
      this.feedUrl = res["feedUrl"];
      this.backofficeUrl = res["backofficeUrl"];
      this.globalDataApi = res["globalDataApi"];
      this.newSignalR = res["newSignalR"];
      this.reportsUrl = res["reportsUrl"];
      this.egxUrl = res["egxUrl"];
      this.appKey = res["appKey"];
      this.idleTime = res["idleTime"];
      this.enableIPO = res["enableIPO"];
      this.enableMutualFund = res["enableMutualFund"];
    });
  }

  public get getFeedUrl() {
    return this.feedUrl;
  }
  get getBackofficeUrl() {
    return this.backofficeUrl;
  }
  get getGlobalDataApi() {
    return this.globalDataApi;
  }
  get getAppKey() {
    return this.appKey;
  }
  public get getIdleTime() {
    return this.idleTime;
  }
}
